/**
 * Geo-Redirect MVP Initialization
 * Integrates with Shopify theme settings
 */

(function() {
  'use strict';
  
  // Skip if geo-targeting is disabled
  
  
  // Skip if URL includes disable flag
  if (window.location.search.includes('geo=false')) {
    return;
  }

  // Check for manual override FIRST (before any other logic)
  try {
    // If override=1 parameter exists, set permanent flag and exit
    if (window.location.search.includes('override=1')) {
      localStorage.setItem('geo_redirect_manual_override', JSON.stringify({
        timestamp: Date.now(),
        selectedStore: window.location.hostname, // Remember which store they chose
        permanent: true // Make this permanent, not time-based
      }));
      console.log('Country selector used - geo redirect permanently disabled for this store');
      return;
    }

    // Check if user has manually selected this store before
    const override = localStorage.getItem('geo_redirect_manual_override');
    if (override) {
      const data = JSON.parse(override);
      // If they're on the same store they manually selected, skip geo redirect
      if (data.selectedStore === window.location.hostname) {
        console.log('User previously selected this store via country selector - skipping geo redirect');
        return;
      }
      // If they're on a different store, allow geo redirect (they might want to switch again)
    }
  } catch (e) {
    console.warn('localStorage not available for geo redirect override:', e);
  }
  
  // Configuration from theme settings
  const geoRedirectConfig = {
    enabled: true,
    currentRegion: 'us',
    shippingCountries: 'us'.split(',').map(c => c.trim().toLowerCase()),
    disableAutoRedirect: true,
    debug: null, // Enable debug on dev stores
    
    storeUrls: {
      
      'us': "https:\/\/kidsrideshotgun.com",
      
      
      'ca': "https:\/\/kidsrideshotgun.ca",
      
      
      'uk': "https:\/\/kidsrideshotgun.co.uk",
      
      
      'eu': "https:\/\/kidsrideshotgun.eu",
      
      
      'de': "https:\/\/kidsrideshotgun.de",
      
      
      'fr': "https:\/\/kidsrideshotgun.fr",
      
      
      'es': "https:\/\/kidsrideshotgun.es",
      
      
      'au': "https:\/\/kidsrideshotgun.com.au",
      
      
      'nz': "https:\/\/kidsrideshotgun.co.nz",
      
    }
  };
  
  // Remove empty store URLs
  Object.keys(geoRedirectConfig.storeUrls).forEach(key => {
    if (!geoRedirectConfig.storeUrls[key]) {
      delete geoRedirectConfig.storeUrls[key];
    }
  });
  
  // Expose shipping restriction message for modal use
  window.themeSettings = window.themeSettings || {};
  window.themeSettings.shippingRestrictionMessage = `We currently do not ship to your region. Please check our stockist page.`;
  window.themeSettings.shippingRestrictedCountries = `ch,ie,no`;
  window.themeSettings.stockistPageUrl = `/pages/find-stockist`;
  
  // Initialize when DOM is ready and GeoRedirectMVP is available
  function initGeoRedirect() {
    if (typeof GeoRedirectMVP === 'undefined') {
      console.warn('GeoRedirectMVP class not found. Make sure geo-redirect-mvp.js is loaded first.');
      return;
    }
    
    const geoRedirect = new GeoRedirectMVP(geoRedirectConfig);
    geoRedirect.init();
    
    // Add to window for debugging
    if (geoRedirectConfig.debug) {
      window.geoRedirectMVP = geoRedirect;
      console.log('GeoRedirectMVP initialized with config:', geoRedirectConfig);
    }
  }
  
  // Wait for DOM and ensure script is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGeoRedirect);
  } else {
    // DOM already loaded
    setTimeout(initGeoRedirect, 100);
  }
  
})(); 